import Vue from 'vue';
import Vuelidate, {validationMixin} from 'vuelidate'
import {email, required} from 'vuelidate/lib/validators';

import {mapActions, mapMutations} from "vuex";

import {AUTH_RESTORE_PASSWORD} from "@/store/action-types";

import {AUTH_SHOW_POPUP_RESTORE_PASSWORD, POPUP_TEXT_CONTENT, SHOW_POPUP_TEXT_CONTENT} from '@/store/mutation-types'

Vue.use(Vuelidate);

export default {
    name: 'restore-password-email',
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                email: ''
            },
            validationErrors: {
                email: []
            }
        }
    },
    validations: {
        payload: {
            email: {
                required,
                email
            },
        }
    },
    watch: {
        'payload.email'() {
            let error = [];

            if (!this.$v.payload.email.required) {
                error.push(this.$t('fieldRequired').replace(':name', this.$t('email')))
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t('validationEmail'))
            }

            this.validationErrors.email = error;
        },
    },
    computed: {
        disableButton() {
            if (
                this.payload.email === ''
            ) {
                return true
            } else {
                return false
            }
        },
        errorsMessages() {
            let errors = [];
            for (let i in this.validationErrors) {
                this.validationErrors[i].forEach(e => {
                    errors.push(e);
                })
            }
            return errors;
        },
    },
    methods: {
        ...mapActions({
            send: `auth/${AUTH_RESTORE_PASSWORD}`
        }),
        ...mapMutations({
            showPopup: `system/${SHOW_POPUP_TEXT_CONTENT}`,
            changeShowPopupRestore: `auth/${AUTH_SHOW_POPUP_RESTORE_PASSWORD}`,
            changeContentPopup: `system/${POPUP_TEXT_CONTENT}`,
        }),
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.send(this.payload)
                    .then(resp => {
                        this.changeShowPopupRestore(false);
                        this.changeContentPopup({
                            title: this.$t('restorePassword'),
                            text: 'Вам на электронную почту было отправлено письмо, ' +
                                'чтоб изменить пароль, следуйте инструкции в письме'
                        });
                        this.showPopup(true);
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            for (let field in error.response.data.errors) {
                                this.validationErrors[field] = error.response.data.errors[field];
                            }
                        }
                    });


            }
        }
    },
    destroyed() {

    }
}
